"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.parseAxiosError = exports.memoize = exports.unwrapTypeDefinition = exports.typeDefinitionToString = exports.typeUpperToCamelCase = exports.generateFingerPrintToken = exports.generateFingerPrint = exports.encodeUuid = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _speakeasy = _interopRequireDefault(require("speakeasy"));

var encodeUuid = function encodeUuid(uuid_) {
  var _arrayBufferToBase64 = function _arrayBufferToBase64(buffer) {
    var universalBtoa = function universalBtoa(str) {
      try {
        // eslint-disable-next-line no-undef
        return btoa(str);
      } catch (err) {
        // eslint-disable-next-line no-undef
        return Buffer.from(str, "latin1").toString("base64");
      }
    };

    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;

    for (var i = 0; i < len; i += 1) {
      binary += String.fromCharCode(bytes[i]);
    }

    return universalBtoa(binary);
  };

  var parseUuid = function parseUuid(str, buf, offset) {
    var _byteToHex = [];
    var _hexToByte = {};

    for (var i = 0; i < 256; i += 1) {
      _byteToHex[i] = (i + 0x100).toString(16).substr(1);
      _hexToByte[_byteToHex[i]] = i;
    }

    var start = buf && offset || 0;
    var end = 0;
    buf = buf || [];
    str.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
      if (end < 16) {
        // Don't overflow!
        buf[start + end] = _hexToByte[oct];
        end += 1;
      }
    }); // Zero out remaining bytes if string was short

    while (end < 16) {
      buf[start + end] = 0;
      end += 1;
    }

    return buf;
  };

  var bytes = parseUuid(uuid_);

  var base64 = _arrayBufferToBase64(bytes);

  return base64.replace(/\+/g, '-') // Replace + with - (see RFC 4648, sec. 5)
  .replace(/\//g, '_') // Replace / with _ (see RFC 4648, sec. 5)
  .substring(0, 22); // Drop '==' padding
};

exports.encodeUuid = encodeUuid;

var memoize = function memoize(fn, getHash) {
  var cache = {};
  return function () {
    return cache[getHash.apply(void 0, arguments)] || (cache[getHash.apply(void 0, arguments)] = fn.apply(void 0, arguments));
  };
};

exports.memoize = memoize;

var unwrapTypeDefinition = function unwrapTypeDefinition(typeDefinition) {
  if (typeDefinition.kind === 'NON_NULL' || typeDefinition.kind === 'LIST') {
    return unwrapTypeDefinition(typeDefinition.ofType);
  }

  return typeDefinition;
};

exports.unwrapTypeDefinition = unwrapTypeDefinition;

var typeDefinitionToString = function typeDefinitionToString(typeDefinition) {
  if (typeDefinition.kind === 'NON_NULL') {
    return "".concat(typeDefinitionToString(typeDefinition.ofType), "!");
  }

  if (typeDefinition.kind === 'LIST') {
    return "[".concat(typeDefinitionToString(typeDefinition.ofType), "]");
  }

  return typeDefinition.name;
};

exports.typeDefinitionToString = typeDefinitionToString;

var typeUpperToCamelCase = function typeUpperToCamelCase(str) {
  return str ? _lodash.default.chain(str).split('_').map(function (word) {
    return _lodash.default.toUpper(word)[0] + _lodash.default.chain(word).toLower().value().substring(1);
  }).join('').value() : null;
};
/**
 * generate browser fingerprint
 */


exports.typeUpperToCamelCase = typeUpperToCamelCase;

var generateFingerPrint =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    var Fingerprint2, options, fingerPrintComponents;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Fingerprint2 = require('fingerprintjs2');
            options = {
              excludes: {
                adBlock: true,
                fonts: true,
                enumerateDevices: true,
                pixelRatio: true
              }
            };
            _context.next = 4;
            return new Promise(function (resolve) {
              /* global window */
              if (window.requestIdleCallback) {
                window.requestIdleCallback(function () {
                  Fingerprint2.get(options, function (components) {
                    resolve(components);
                  });
                });
              } else {
                window.setTimeout(function () {
                  Fingerprint2.get(options, function (components) {
                    resolve(components);
                  });
                }, 500);
              }
            });

          case 4:
            fingerPrintComponents = _context.sent;
            return _context.abrupt("return", Fingerprint2.x64hash128(_lodash.default.flatMap(fingerPrintComponents, 'value').join(''), 31));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function generateFingerPrint() {
    return _ref.apply(this, arguments);
  };
}();

exports.generateFingerPrint = generateFingerPrint;

var generateFingerPrintToken = function generateFingerPrintToken(fingerptint) {
  return _speakeasy.default.totp({
    secret: fingerptint,
    encoding: 'ascii'
  });
};

exports.generateFingerPrintToken = generateFingerPrintToken;

var parseAxiosError = function parseAxiosError(e) {
  var responseData = _lodash.default.get(e, 'response.data');

  var errorMessage = _lodash.default.get(e, 'message');

  var responseError = _lodash.default.get(responseData, 'error', responseData);

  return _lodash.default.isString(responseError) ? responseError : _lodash.default.isEmpty(responseError) ? errorMessage : JSON.stringify(responseError);
};

exports.parseAxiosError = parseAxiosError;
var _default = {
  encodeUuid: encodeUuid,
  generateFingerPrint: generateFingerPrint,
  generateFingerPrintToken: generateFingerPrintToken,
  typeUpperToCamelCase: typeUpperToCamelCase,
  typeDefinitionToString: typeDefinitionToString,
  unwrapTypeDefinition: unwrapTypeDefinition,
  memoize: memoize,
  parseAxiosError: parseAxiosError
};
exports.default = _default;